import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";

import {deleteForumTopic, moveForumTopic, resetForumTopic, updateForumTopic} from "../../../../creators/forums.topic";

import Avatar from "../../../components/Avatar";
import Title from "../../../components/Title";
import TagList from "../../../components/TagList";
// import Pagination from "../../../components/Pagination";
import Dropdown from "../../../components/Dropdown";
import {Button} from "../../../components/Button";
import ChangeTitle from "./ChangeTitle";
//import TopicFollows from "../../../components/follows/TopicFollows";
import {Can} from "../../../../ability-context";
import MoveForum from '../../../components/MoveForum';
import Modal from "../../../components/Modal";
import DateSince from "../../../components/Date";
// import {config} from "../../../../config";
import createLink from "../../../../libs/createLink";
// import Authenticated from "../../../../libs/Authenticated";
import AdvancedEditorTopic from "../../../components/advanced-editor/AdvancedEditorTopic";
import DraftContentReader from "../../../components/editor/DraftContentReader";
import Report from "../../../components/Report";
import {reportForumTopic} from "../../../../creators/report";
import _ from "lodash";
import {contentRawToText} from "../../../../libs/helper";
import TopicFollows from "../../../components/follows/TopicFollows";
import {resetForumComments} from "../../../../creators/forums.comments";

class TopicHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleChangeTitle: false,
            toggleMoveForum: false,
            toggleAdvancedEditor: false,
            toggleChangeContent: false,
        };
        this.deleteArticle = this.deleteArticle.bind(this);
        this.handleMoveTopic = this.handleMoveTopic.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
        this.handleReport = this.handleReport.bind(this);
    };

    handleStatus(type, status) {
        this.props.updateForumTopic(this.props.forumId, this.props._id, {[type]: status});
    }

    deleteArticle() {
        /*this.props.deleteForumTopic(this.props.forumId, this.props._id);
        let url = this.props.match.url;
        let slug = this.props.match.params.slug;
        let regex = new RegExp(`(.*)${slug}`, 'g');
        let found = url.match(regex);
        if(found && found[0]){

            //window.location.href = found[0];
            //this.props.history.push(found[0]);
        }
        else{
            this.props.history.push(createLink("forum"));
        }*/
        this.props.deleteTopic(this.props.forumId, this.props._id);
    }

    handleMoveTopic(forumId) {
        this.props.moveForumTopic(this.props.forumId, this.props._id, {forumId: forumId});
    }

    handleReport(message){
        this.props.reportForumTopic(this.props.forumId, this.props._id, {message});
    }

    render() {
        let hasOwner = _.get(this.props,"owner._id") !== null;

        return (
            <Fragment>
                <div className="topic-header">
                    <div className="title">
                        <div className="avatar">
                            {hasOwner ? (
                                    <Link to={createLink("userProfile", this.props.owner)}>
                                        <Avatar className="user-avatar" avatar={_.get(this.props,'owner.profile.avatar') || ""}
                                                gender={_.get(this.props,'owner.profile.gender') || 0} alt="" height={80} width={80}/>
                                    </Link>) :
                                <Avatar className="user-avatar" gender="guest" alt=""/>
                            }
                        </div>
                        <div className="info-topic">
                            {(!this.props.isApproved || !this.props.isOpened || this.props.isPinned || this.props.isPoll) && (
                                <div className="before-title">
                                    {!this.props.isApproved && (
                                        <span className="badge closed">Refusé</span>
                                    )}
                                    {!this.props.isOpened && (
                                        <span className="badge closed" title="Le modérateur interdit toute réponse sur ce sujet">Verrouillé</span>
                                    )}
                                    {this.props.isPinned && (
                                        <span className="badge pinned" title="Cette discussion est toujours affichée en premier">Épinglé</span>
                                    )}
                                    {this.props.isPoll && (
                                        <span className="badge poll">Sondage</span>
                                    )}
                                </div>
                            )}
                            <Title heading={"heading-1"} display={"display-2"}>
                                {this.props.title || ""}
                            </Title>
                            <span className="topic-by">Débuté par {hasOwner ? (
                                <Link className={"username"}
                                      to={createLink("userProfile", this.props.owner)}>{this.props?.owner?.username}</Link>) : (`Guest_${this.props.authorName}`)}</span>
                            <div className="date">
                                <DateSince
                                    date={this.props.createdAt}
                                    prefix={true}
                                    currentFormat={true}
                                />
                            </div>
                            {this.props.tags?.length ? <TagList tags={this.props.tags.map(item => {delete item.slug; return item}) || []}/> : null}
                        </div>
                    </div>
                    {this.props.currentPage === 1 ? (
                        <div className="follow-topic column pb-8 w-100">
                            {/*{this.props.currentUser._id && (*/}
                            <TopicFollows
                                forumId={this.props.forumId}
                                topicId={this.props._id}
                                isFollow={this.props.isFollow}
                            />
                            {/*)}*/}
                        </div>
                    ) : null}
                    {/*<div className="follow-topic column pb-8">
                        {/*{this.props.currentUser._id && (*/}
                    {/*<TopicFollows forumId={this.props.forumId} topicId={this.props._id}
                                          isFollow={this.props.isFollow}/>
                        {/*)}*/}
                    {/*}</div>*/}
                </div>
                <div className={"first-message"}>
                    {/*<span className={`first-message-label ${config.genderClass[hasOwner ? this.props.owner.profile.gender : 0]}`}>Message du sujet :</span>*/}
                    <div className={"content"}>
                        <DraftContentReader
                            extendedProps={{
                                forumId : this.props.forumId,
                                topicId : this.props._id,
                            }}
                            contentRaw={this.props.contentRaw}/>
                    </div>
                    {!this.props.currentUser?.setting?.notDisplaySignatureInForum && this.props.useSign && _.get(this.props,"owner.setting.signature.contentRaw") && contentRawToText(this.props?.owner?.setting?.signature?.contentRaw).length !== 0 ? (
                        <div className="user-sign">
                            <DraftContentReader contentRaw={this.props.owner.setting.signature.contentRaw}/>
                        </div>
                    ) : null}
                </div>
                <div className="answer-topic">
                    {/*<div className="wrapper-settings">*/}
                    {/*    {this.props.totalPage > 1 &&*/}
                    {/*    <Pagination*/}
                    {/*        currentPage={this.props.filter.page}*/}
                    {/*        pagesCount={this.props.totalPage}*/}
                    {/*        paginationLength={7}*/}
                    {/*        link={createLink("forumTopic", {categoryParent : {slug : this.props.match.params.slugParent}, category : {_id : this.props.forum._id, slug : this.props.forum.slug}, topic : {_id : this.props._id, slug : this.props.slug}})}*/}
                    {/*        handleChangePage={this.props.handleChangePage}*/}
                    {/*    />*/}
                    {/*    }*/}
                    {/*</div>*/}
                    <div className="row ml-auto btn-group-answer-admn">
                        {/*TODO: right*/}
                        <Can action={"moderation"} subject={this.props} modelName="Topic">
                            <div className="answer-topic-admin-button">
                                <Dropdown align="right" activableComponent={(
                                    <Button size={"small"}
                                            btnStyle={"cancel-reverse"}
                                            content="Modération du sujet"/>
                                )}>
                                    <ul className="dropdown-menu">
                                        <Can action={"update"} subject={this.props} modelName="Topic">
                                            <li className="menu-item"
                                                onClick={() => this.setState({toggleChangeTitle: true})}>Modifier le titre
                                            </li>
                                        </Can>
                                        <Can action={"update"} subject={this.props} modelName={"Topic"}>
                                            <li className="menu-item"
                                                onClick={() => this.setState({toggleChangeContent: true})}>Modifier le contenu
                                            </li>
                                        </Can>
                                        <Can action={"is-pinned"} subject={this.props} modelName="Topic">
                                            <li className="menu-item" onClick={() => this.handleStatus('isPinned', !this.props.isPinned)}>
                                                {this.props.isPinned ? "Désépingler" : "Epingler"}
                                            </li>
                                        </Can>
                                        <Can action={"is-opened"} subject={this.props} modelName="Topic">
                                            <li className="menu-item" onClick={() => this.handleStatus('isOpened', !this.props.isOpened)}>
                                                {this.props.isOpened ? "Fermer" : "Ouvert"}
                                            </li>
                                        </Can>
                                        <Can action={"move"} subject={this.props} modelName="Topic">
                                            <li className="menu-item" onClick={() => this.setState({toggleMoveForum: true})}>
                                                Déplacer
                                            </li>
                                        </Can>
                                        <Can action={"is-approved"} subject={this.props} modelName="Topic">
                                            <li className="menu-item" onClick={() => this.handleStatus('isApproved', !this.props.isApproved)}>
                                                {this.props.isApproved === false ? "Accepter" : "Refuser"}
                                            </li>
                                        </Can>
                                        <Can action={"delete"} subject={this.props} modelName="Topic">
                                            <li className="menu-item" onClick={() => this.deleteArticle()}>
                                                Supprimer
                                            </li>
                                        </Can>

                                    </ul>
                                </Dropdown>
                            </div>
                        </Can>
                        <Can action={"report"} subject={this.props} modelName="Topic">
                            <div className="report-btn">
                                <Report _id={this.props._id}
                                        kind={"topics"}
                                        type={"button"}
                                        handleReport={this.handleReport}
                                        title={this.props.title}/>
                            </div>
                        </Can>
                        <Can action={"quote"} subject={this.props} modelName="Topic">
                            <Button className={"multi ml-16"}
                                    active={this.props.quotesIds.includes(this.props._id.toString())}
                                    size={"small"}
                                    btnStyle={"primary"}
                                    onClick={() => this.props.handleMultipleQuotes({
                                        _id: this.props._id,
                                    })}
                                    content={"Multi-citation"}/>
                        </Can>
                        <Can action={"quote"} subject={this.props} modelName="Topic">
                            <Button
                                className={"ml-16"}
                                size={"small"}
                                btnStyle={"primary-reverse"}
                                onClick={() => this.props.quote({
                                    _id: this.props._id,
                                })}
                                content="Citer"
                            />
                        </Can>
                        {/*TODO : right*/}
                        {/*<Authenticated passThrough>*/}
                        {/*    {authenticated=>{*/}
                        {/*        return authenticated ? (*/}
                        {/*            <Can action={"create"} subject={this.props} modelName="Topic">*/}
                        {/*                {can=>{*/}
                        {/*                    return can ? (*/}
                        {/*                        <Button className="answer-topic-answer-btn"*/}
                        {/*                                size={"small"}*/}
                        {/*                                btnStyle={"primary-reverse"}*/}
                        {/*                                onClick={() => this.setState({toggleAnswer: true})}*/}
                        {/*                                content="Répondre à ce sujet"/>*/}
                        {/*                    ) : (*/}
                        {/*                        <Button className="answer-topic-answer-btn"*/}
                        {/*                                size={"grey"}*/}
                        {/*                                btnStyle={"primary-reverse"}*/}
                        {/*                                content="Vous ne pouvez pas répondre à ce sujet"/>*/}
                        {/*                    )}}*/}
                        {/*            </Can>*/}
                        {/*        ) : (*/}
                        {/*            <Button className="answer-topic-answer-btn"*/}
                        {/*                    to={createLink("signin")}*/}
                        {/*                    size={"small"}*/}
                        {/*                    content="Veuillez vous connecter pour répondre"/>*/}
                        {/*        )}}*/}
                        {/*</Authenticated>*/}

                    </div>
                    <Modal toggle={this.state.toggleChangeContent} handleClose={()=>this.setState({toggleChangeContent: false})}>
                        <AdvancedEditorTopic  title={this.props.title}
                                              topicId={this.props._id}
                                              forumId={this.props.forumId}
                                              handleClose={()=>this.setState({toggleChangeContent: false})} />
                    </Modal>
                    <Modal toggle={this.state.toggleChangeTitle}
                           handleClose={() => this.setState({toggleChangeTitle: false})}>
                        <ChangeTitle
                            title={this.props.title}
                            articleId={this.props._id}
                            forumId={this.props.forumId}
                            handleStatus={this.handleStatus}
                            handleClose={() => this.setState({toggleChangeTitle: false})}
                            reloadArticle={this.props.reloadArticle}
                        />
                    </Modal>
                    <Modal toggle={this.state.toggleMoveForum}
                           handleClose={() => this.setState({toggleMoveForum: false})}>
                        <MoveForum handleClose={() => this.setState({toggleMoveForum: false})}
                                   handleMoveTopic={this.handleMoveTopic}/>
                    </Modal>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentUser : state.currentUser.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateForumTopic,
    deleteForumTopic,
    resetForumTopic,
    moveForumTopic,
    reportForumTopic,
    resetForumComments
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TopicHeader);